import React from 'react';

const ConfirmModal = ({ title, onConfirm, onCancel, confirmText, cancelText, invertButtonTheme }) => {
    
    React.useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onCancel();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onCancel]);
    return (
        <div className="confirmModal" role="dialog" aria-labelledby="modal-title" tabIndex="-1">
            <div className="confirmModal__content">
                <h1 id="modal-title" className='heading4 mb-7'>{title}</h1>
                <div className="confirmModal__buttons">
                    <button 
                        className={`btn btn-sm thule-btn-${invertButtonTheme ? "secondary" : "default"}`} 
                        onClick={onConfirm} 
                        aria-label={confirmText}
                    >
                        {confirmText}
                    </button>
                    <button 
                        className={`btn btn-sm thule-btn-${invertButtonTheme ? "default" : "secondary"}`} 
                        onClick={onCancel} 
                        aria-label={cancelText}
                    >
                        {cancelText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;